'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uxcore = require('@ux/uxcore2');

var _reactIdleTimer = require('react-idle-timer');

var _reactIdleTimer2 = _interopRequireDefault(_reactIdleTimer);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _intentManager = require('./intent-manager.js');

var _intentManager2 = _interopRequireDefault(_intentManager);

var _stateManager = require('./state-manager.js');

var _stateManager2 = _interopRequireDefault(_stateManager);

var _trafficManager = require('./traffic-manager.js');

var _trafficManager2 = _interopRequireDefault(_trafficManager);

var _settingsManager = require('./settings-manager.js');

var _settingsManager2 = _interopRequireDefault(_settingsManager);

var _livePersonManager = require('./live-person-manager');

var _livePersonManager2 = _interopRequireDefault(_livePersonManager);

var _errorBoundary = require('./error-boundary.js');

var _errorBoundary2 = _interopRequireDefault(_errorBoundary);

var _button = require('./bot-action/button.js');

var _button2 = _interopRequireDefault(_button);

var _diagnostics = require('./bot-action/diagnostics.js');

var _diagnostics2 = _interopRequireDefault(_diagnostics);

var _image = require('./bot-action/image.js');

var _image2 = _interopRequireDefault(_image);

var _link = require('./bot-action/link.js');

var _link2 = _interopRequireDefault(_link);

var _searchResults = require('./bot-action/search-results.js');

var _searchResults2 = _interopRequireDefault(_searchResults);

var _api = require('./bot-action/api.js');

var _api2 = _interopRequireDefault(_api);

var _text = require('./bot-action/text.js');

var _text2 = _interopRequireDefault(_text);

var _welcome = require('./bot-action/welcome');

var _welcome2 = _interopRequireDefault(_welcome);

var _waitTimeClock = require('./bot-action/wait-time-clock');

var _waitTimeClock2 = _interopRequireDefault(_waitTimeClock);

var _agentImage = require('./lp-action/agent-image');

var _agentImage2 = _interopRequireDefault(_agentImage);

var _agentEnded = require('./lp-action/agent-ended');

var _agentEnded2 = _interopRequireDefault(_agentEnded);

var _liveAgentText = require('./lp-action/live-agent-text.js');

var _liveAgentText2 = _interopRequireDefault(_liveAgentText);

var _input = require('./user-action/input');

var _input2 = _interopRequireDefault(_input);

var _input3 = require('./components/input');

var _input4 = _interopRequireDefault(_input3);

var _loading = require('./components/loading');

var _loading2 = _interopRequireDefault(_loading);

var _overlay = require('./components/overlay');

var _overlay2 = _interopRequireDefault(_overlay);

var _styles = require('./components/styles');

var _styles2 = _interopRequireDefault(_styles);

var _botUtils = require('./bot-utils');

var _app = require('./store/actions/app');

var _eventManager = require('./event-manager.js');

var _responseHandlers = require('./response-handlers');

var _conversation = require('./store/actions/conversation');

var _conversation2 = require('./store/selectors/conversation');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-console */
/* eslint-disable no-nested-ternary */


var chatbotApiBaseHostname = 'origin-chatbots-api';
var regions = { Phx: '-phx3', Iad: '-iad2', Ams: '-ams3' };
var userIdleTime = 1000 * 60 * 5;
var containerClosedEvent = 'containerClosed';
var endChatOrStartOverEvent = 'endChatOrStartOver';

var wait = function wait(milliseconds) {
  return new Promise(function (resolve) {
    return setTimeout(function () {
      return resolve();
    }, milliseconds);
  });
};

/**
 * HelpBot React component
 *
 * @Constructor
 * @class HelpBot
 * @public
 */

var HelpBot = function (_Component) {
  _inherits(HelpBot, _Component);

  function HelpBot(props) {
    _classCallCheck(this, HelpBot);

    var _this = _possibleConstructorReturn(this, (HelpBot.__proto__ || Object.getPrototypeOf(HelpBot)).call(this, props));

    var productId = _stateManager2.default.getProductContext(_this.props.conversation, _this.props.productId);

    _this.envPrefix = _this.props.env === 'prod' ? '' : _this.props.env === 'test' ? 'test-' : 'dev-';
    _this.doDiagnostics = _this.envPrefix === 'dev-';

    var suffix = _this.props.env === 'prod' ? regions[_this.props.region] || regions.Phx : '';
    var url = _this.props.chatbotsApiUrl ? _this.props.chatbotsApiUrl : 'https://' + (chatbotApiBaseHostname + suffix) + '.' + _this.envPrefix + 'godaddy.com';

    _this.state = {
      productId: productId,
      highSentimentThreshold: _settingsManager2.default.highSentimentThreshold,
      autoEscalateThreshold: _settingsManager2.default.autoEscalateThreshold,
      botTypingIndicator: false,
      endChatConfirmed: false,
      liveAgent: false,
      liveAgentAvailable: false,
      liveAgentConnecting: false,
      liveAgentTyping: false,
      messageText: '',
      previousMessageText: '',
      promptClose: false,
      closePromptTitle: _this.props.intl.messages['Support:HelpBot:Close:Prompt'],
      closePromptText: '',
      closePromptContinueText: '',
      closePromptCancelText: '',
      chatbotsApiBaseUrl: url,
      dialogFlowValues: {}
    };

    _this.getFallbackIntentEventId = _this.getFallbackIntentEventId.bind(_this);
    _this.handleChatMessage = _this.handleChatMessage.bind(_this);
    _this.handleEndChatOrStartOver = _this.handleEndChatOrStartOver.bind(_this);
    _this.locationChange = _this.locationChange.bind(_this);
    _this.onChatDialogScroll = _this.onChatDialogScroll.bind(_this);
    _this.onUserActive = _this.onUserActive.bind(_this);
    _this.onUserIdle = _this.onUserIdle.bind(_this);
    _this.receiveMessage = _this.receiveMessage.bind(_this);
    _this.sendUserMessage = _this.sendUserMessage.bind(_this);
    _this.sendUserMessageText = _this.sendUserMessageText.bind(_this);
    _this.setBotProjectId = _this.setBotProjectId.bind(_this);
    _this.setMessageText = _this.setMessageText.bind(_this);
    _this.triggerEvent = _this.triggerEvent.bind(_this);
    return _this;
  }

  /**
   * React method called before component mounted
   *
   * @private
   */


  _createClass(HelpBot, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      _livePersonManager2.default.initialize(this);
    }

    /**
     * React method called after component mounted
     *
     * @private
     */

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('message', this.receiveMessage);

      this.chatDialog.addEventListener('scroll', this.onChatDialogScroll);

      if (window && window.parent !== window) {
        window.parent.postMessage('inappHelpEnableClosePrompt', '*');
      }

      this.welcomeIfNewOrProductChanged();

      this.props.appBlockedSet(false);
      this.props.conversationProcessingSet(false);

      if (this.props.conversation.length) {
        this.performScroll(true);
        this.props.conversationSet(this.props.conversation.map(function (item) {
          item.shown = true;
          return item;
        }));
      }

      // poll for changes to liveEngageChatId
      setInterval(function () {
        var chatIdSession = window.sessionStorage.getItem('liveEngageChatId');
        var chatIdLocal = window.localStorage.getItem('liveEngageChatId');
        if (chatIdLocal && chatIdSession !== chatIdLocal) {
          !_this2.props.appChatInProgressElsewhere && _this2.props.appChatInProgressElsewhereSet(true);
        } else {
          _this2.props.appChatInProgressElsewhere && _this2.props.appChatInProgressElsewhereSet(false);
        }
      }, 500);
      // remove liveEngageChatId on unload
      window.addEventListener('beforeunload', function () {
        window.localStorage.removeItem('liveEngageChatId');
        return null;
      });
    }

    /**
     * React method called after component updated
     *
     * @param {Object} prevProps previous props
     * @param {Object} prevState previous state
     *
     * @private
     */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.appScrolled) {
        this.performScroll();
      }

      this.updateClosePromptStrings(prevState);
    }

    /**
     * React method called before component unmounted
     *
     * @private
     */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.receiveMessage);
      this.chatDialog.removeEventListener('scroll', this.onChatDialogScroll);
    }

    /**
     * Called when there is no user activity for the defined userIdleTime.
     * Sends traffic event to indicate user inactivity.
     *
     * @private
     */

  }, {
    key: 'onUserIdle',
    value: function onUserIdle() {
      _trafficManager2.default.sendEvent('custom', 'cx.help-bot.user.activity.idle', []);
    }

    /**
     * Called when there is user activity after having been idle.
     * Sends traffic event to indicate user resumed activity.
     *
     * @private
     */

  }, {
    key: 'onUserActive',
    value: function onUserActive() {
      _trafficManager2.default.sendEvent('custom', 'cx.help-bot.user.activity.active', []);
    }
  }, {
    key: 'getFallbackIntentEventId',
    value: function getFallbackIntentEventId() {
      var productId = this.state.productId;

      return 'welcome-' + (productId || 'default');
    }

    /**
     * Triggers welcome event if new conversation or product changed.
     *
     * @param {string} customWelcomeIntentId defined in dialog flow
     * @private
     */

  }, {
    key: 'welcomeIfNewOrProductChanged',
    value: function welcomeIfNewOrProductChanged() {
      var _props = this.props,
          conversation = _props.conversation,
          welcomeIntent = _props.welcomeIntent;
      var productId = this.state.productId;


      var previousProductId = _stateManager2.default.getPreviousProductId();

      var welcomeIntentId = welcomeIntent || this.getFallbackIntentEventId();

      _stateManager2.default.clearPreviousProduct();

      if (!conversation.length) {
        this.props.conversationAppend({ msgType: 'welcome' });
        this.triggerEvent(welcomeIntentId);
      } else if (previousProductId && previousProductId !== productId) {
        this.triggerEvent(welcomeIntentId);
      }
    }

    /**
     * Set scrolled state on every scroll, based on scroll and height values
     *
     * @private
     */

  }, {
    key: 'onChatDialogScroll',
    value: function onChatDialogScroll() {
      var _chatDialog = this.chatDialog,
          offsetHeight = _chatDialog.offsetHeight,
          scrollHeight = _chatDialog.scrollHeight,
          scrollTop = _chatDialog.scrollTop;

      var difference = scrollHeight - (offsetHeight + scrollTop);
      this.props.appScrolledSet(difference < 1);
    }

    /**
     * Logic for performing instant scroll or 'interval'ed smooth scrolling to bottom of chat
     *
     * @param {boolean} instant Force scroll instantly with no smooth interval
     * @private
     */

  }, {
    key: 'performScroll',
    value: function performScroll(instant) {
      var _this3 = this;

      if (!this.chatDialog) return;

      if (instant) {
        this.chatDialog.scrollTop = this.chatDialog.scrollHeight;
      } else if (this.chatDialog.scrollTop + this.chatDialog.offsetHeight < this.chatDialog.scrollHeight) {
        var scrollInterval = setInterval(function () {
          var difference = _this3.chatDialog.scrollHeight - (_this3.chatDialog.scrollTop + _this3.chatDialog.offsetHeight);
          var increment = Math.ceil(difference / 5);

          increment === 1 ? _this3.chatDialog.scrollTop = _this3.chatDialog.scrollHeight : _this3.chatDialog.scrollTop = _this3.chatDialog.scrollTop + increment;

          if (_this3.chatDialog.scrollHeight - (_this3.chatDialog.scrollTop + _this3.chatDialog.offsetHeight) < 1) {
            _this3.chatDialog.scrollTop = _this3.chatDialog.scrollHeight;
            clearInterval(scrollInterval);
          }
        }, 20);
      }
    }

    /**
     * Close the chatbot container
     *
     * @private
     */

  }, {
    key: 'close',
    value: function close() {
      _stateManager2.default.setProductContext('');

      if (this.state.liveAgentConnecting || this.state.liveAgent) {
        _livePersonManager2.default.endConnection(containerClosedEvent);
      }

      _trafficManager2.default.sendEvent('click', 'cx.help-bot.dialog.close_button.click', [['bsid', this.props.sessionId]]);

      if (window && window.parent !== window) {
        // allow a few cycles for traffic events and postToLog to finish before closing container
        setTimeout(function () {
          window.parent.postMessage('inappHelpClose', '*');
        }, 250);
      }
    }

    /**
     * Compare previous state to update close prompt strings
     *
     * @param {Object} prevState previous state
     *
     * @private
     */

  }, {
    key: 'updateClosePromptStrings',
    value: function updateClosePromptStrings(prevState) {
      var _this4 = this;

      if (this.state.liveAgentConnecting !== prevState.liveAgentConnecting || this.state.liveAgent !== prevState.liveAgent) {
        var newState = {};

        var getPromptTextString = function getPromptTextString(message) {
          return _this4.props.intl.messages[message];
        };

        if (this.state.liveAgentConnecting) {
          newState.closePromptText = getPromptTextString('Support:HelpBot:Close:PromptTextQueue');
          newState.closePromptContinueText = getPromptTextString('Support:HelpBot:Close:ContinueQueue');
          newState.closePromptCancelText = getPromptTextString('Support:HelpBot:Close:CancelQueue');
        } else if (this.state.liveAgent) {
          newState.closePromptText = getPromptTextString('Support:HelpBot:Close:PromptTextAgent');
          newState.closePromptContinueText = getPromptTextString('Support:HelpBot:Close:ContinueAgent');
          newState.closePromptCancelText = getPromptTextString('Support:HelpBot:Close:CancelAgent');
        } else {
          newState.closePromptText = '';
          newState.closePromptContinueText = '';
          newState.closePromptCancelText = '';
          this.setState({
            promptClose: false
          });
        }

        this.setState(newState);
      }
    }

    /**
     * Trigger dialogflow event by name
     *
     * @param {string} eventName The name of the dialogflow event to trigger
     * @param {string} buttonLabel The label of the button that wants to trigger event
     * @private
     */

  }, {
    key: 'triggerEvent',
    value: function triggerEvent(eventName, buttonLabel) {
      var _this5 = this;

      var query = buttonLabel || '';
      this.displayBotTypingIndicator(true);
      _uxcore.utils.request.get(this.getChatbotApiUrl() + query + ('&e=' + eventName), { mode: 'cors' }, function (err, data) {
        err = err || data && data.err || null;
        if (err) {
          setTimeout(function () {
            return _this5.displayBotTypingIndicator(false);
          }, _botUtils.BOT_TYPING_DELAY);
          return _this5.handleNoResponse(err);
        }
        return _this5.handleResponse('', data);
      });
    }

    /**
     * @returns {string} chat bot api Url with current message and previous message
     * @param {string} currentMessage current user typed text
     * @private
     */

  }, {
    key: 'getChatbotApiUrl',
    value: function getChatbotApiUrl(currentMessage) {
      var botProjectId = this.props.botProjectId;
      var _state = this.state,
          chatbotsApiBaseUrl = _state.chatbotsApiBaseUrl,
          productId = _state.productId,
          previousMessageText = _state.previousMessageText;

      var visitorId = (0, _botUtils.getVisitorId)();
      var botProjectIdQuery = botProjectId ? '&projectId=' + botProjectId : '';
      var chatbotApiUrl = chatbotsApiBaseUrl + '/detectIntent?vid=' + visitorId + '&sid=' + this.props.sessionId + '&pid=' + productId + ('&prev=' + previousMessageText + botProjectIdQuery + '&q=');

      if (currentMessage) {
        chatbotApiUrl += currentMessage;
        this.setState({ previousMessageText: currentMessage });
      }
      return chatbotApiUrl;
    }

    /**
     * @returns {string} message type from custom payload if an
     *
     * @param {Object} msg The fullfillment message from dialogflow
     * @private
     */

  }, {
    key: 'getMessageType',
    value: function getMessageType(msg) {
      if (msg.message === 'text') {
        return 'text';
      } else if (msg.message === 'payload' && msg.payload.fields.type) {
        return msg.payload.fields.type.stringValue;
      }
      return 'unknown';
    }

    /**
     * Trigger window location change by url
     *
     * @param {string} url The url to redirect the current window
     * @private
     */

  }, {
    key: 'locationChange',
    value: function locationChange(url) {
      this.props.locationChange(url);
    }

    /**
     * @returns {Object} query string as associative array
     *
     * @private
     */

  }, {
    key: 'getQueryParams',
    value: function getQueryParams() {
      var query = {};
      var qs = window.location.search;
      if (qs) {
        qs = qs.slice(1);
        qs = qs.split('&');
        qs.map(function (param) {
          param = param.split('=');
          query[param[0]] = param.length > 1 ? param[1] : '';
        });
      }
      return query;
    }

    /**
     * Checks sentiment score and conditionally sends traffic event based on the
     * sentiment analysis score returned and the defined high sentiment threshold.
     *
     * @param {Object} response The response from dialogflow containing sentiment score
     * @private
     */

  }, {
    key: 'checkSentiment',
    value: function checkSentiment(response) {
      if (response.queryResult && response.queryResult.sentimentAnalysisResult && response.queryResult.sentimentAnalysisResult.queryTextSentiment.score > this.state.highSentimentThreshold) {
        _trafficManager2.default.sendEvent('custom', 'cx.help-bot.user.sentiment.high', []);
      }
    }

    /**
     * Display or hide chatbot typing indicator
     *
     * @param {string} showIndicator true/false whether to display the typing indicator
     * @private
     */

  }, {
    key: 'displayBotTypingIndicator',
    value: async function displayBotTypingIndicator(showIndicator) {
      if (showIndicator) {
        // delay before showing bot typing indicator
        await wait(_botUtils.BOT_TYPING_DELAY);
        this.setState({ botTypingIndicator: true });
      } else {
        // turn off typing indicator immediately
        this.setState({ botTypingIndicator: false });
      }
    }

    /**
     * Helper method to append to conversation with a properly formatted msg
     *
     * @param {string} text The text to use
     * @private
     */

  }, {
    key: 'appendTextToConversation',
    value: function appendTextToConversation(text) {
      this.props.conversationAppend({
        msg: { text: { text: [text] } },
        msgType: 'text',
        sessionId: this.props.sessionId
      });
    }
  }, {
    key: 'processQueue',
    value: async function processQueue() {
      if (!this.props.conversationProcessing) {
        var messages = this.props.conversationQueue[0];
        this.props.conversationQueueShift();

        if (messages) {
          this.props.appBlockedSet(true);
          this.props.conversationProcessingSet(true);

          for (var i = 0; i < messages.length; i++) {
            var message = messages[i];

            var shortDelay = this.props.conversation.filter(function (item) {
              return item.msgType === 'text';
            }).length === 0;
            var thisDelay = shortDelay ? 500 : (0, _botUtils.getDelayFromMessage)(message);

            if (thisDelay) {
              await this.displayBotTypingIndicator(true);
              await wait(thisDelay);
            }

            this.displayBotTypingIndicator(false);
            this.props.conversationAppend(message);
          }

          this.props.conversationProcessingSet(false);
          this.props.appBlockedSet(false);
          this.processQueue();
        }
      }
    }

    /**
     * Adds messages to conversational state
     *
     * @param {string} userMessageText The user message sent to dialog flow
     * @param {Object} response The response object
     * @private
     */

  }, {
    key: 'addDialogMessages',
    value: function addDialogMessages(userMessageText, response) {
      var _this6 = this;

      if (!response.queryResult.fulfillmentMessages) {
        return;
      }

      var responseMsgs = [];
      response.queryResult.fulfillmentMessages.map(function (msg) {
        var msgType = _this6.getMessageType(msg);
        var data = { msgType: msgType, msg: msg, response: response, responseMsgs: responseMsgs, userMessageText: userMessageText, helpBot: _this6 };
        switch (msgType) {
          case 'search':
            (0, _responseHandlers.handleSearchMessage)(data);
            break;
          case 'api':
            (0, _responseHandlers.handleApiMessage)(data);
            break;
          case 'authCheck':
            (0, _responseHandlers.handleAuthCheckMessage)(data);
            return;
          case 'queryBotAgent':
            (0, _responseHandlers.handleQueryBotAgentMessage)(data);
            return;
          case 'event':
            var eventMessage = { msg: msg, msgType: msgType, intent: response.queryResult.intent, sessionId: _this6.props.sessionId };
            (0, _eventManager.handleEventMessage)(eventMessage, _this6);
            return;
          case 'settings':
            _settingsManager2.default.updateSettings(_this6, msg);
            return;
          case 'postToCRM':
            _livePersonManager2.default.sendConversationToCRM(_this6.state.chatbotsApiBaseUrl);
            return;
          case 'agentTransfer':
            if (_this6.state.liveAgentAvailable) {
              _this6.liveAgentTransfer(response);
            } else {
              _this6.triggerEvent(_livePersonManager2.default.phoneEscalateEvent);
            }
            break;
          case 'setBotAgent':
            msg.payload.fields.botProjectId && (0, _responseHandlers.handleSetBotAgent)(data);
            return;
          case 'setState':
            (0, _responseHandlers.handleSetStateMessage)(data);
            break;
          case 'validator':
            (0, _responseHandlers.handleValidationMessage)(data);
            break;
          default:
            responseMsgs.push({
              msg: msg,
              msgType: msgType,
              userMessageText: userMessageText,
              intent: response.queryResult.intent,
              escalate: response.queryResult.escalate,
              split: response.queryResult.split,
              sessionId: _this6.props.sessionId
            });
        }
      });

      if (responseMsgs.length) {
        this.props.conversationQueueAppend(responseMsgs);
        this.processQueue();
      }
    }
  }, {
    key: 'liveAgentTransfer',
    value: function liveAgentTransfer(response) {
      _trafficManager2.default.sendChatEscalateEvent(response, this.props.sessionId, this.state.productId);
      this.displayBotTypingIndicator(false);
      this.setState({ liveAgent: true });

      // allow time for any bot responses before transfer
      setTimeout(function () {
        _livePersonManager2.default.transferToAgent();
      }, _botUtils.BOT_RESPONSE_DELAYS.short);
    }

    /**
     * Adds diagnostic info to conversational state
     *
     * @param {Object} response The response object
     * @private
     */

  }, {
    key: 'addDiagnosticInfo',
    value: function addDiagnosticInfo(response) {
      this.props.conversationAppend({
        msgType: 'diag',
        response: response,
        productId: this.state.productId,
        sessionId: this.props.sessionId,
        intent: response.queryResult.intent
      });
    }

    /**
     * Handle posted messages to Iframe to support conditional closing
     *
     * @param {Event} event Posted message event.
     * @private
     */

  }, {
    key: 'receiveMessage',
    value: function receiveMessage(event) {
      if (window.parent !== event.source) {
        return;
      }

      if (event.data !== 'inappHelpPromptClose') {
        return;
      }

      if (this.state.closePromptText) {
        this.setState({ promptClose: true });
      } else {
        this.close();
      }
    }
  }, {
    key: 'handleChatMessage',
    value: function handleChatMessage(messageText) {
      this.props.onChatMessage && this.props.onChatMessage(messageText);
    }

    /**
     * Handle response data
     *
     * @param {string} userMessageText The user message sent to dialog flow
     * @param {Object} data The response data
     * @private
     */

  }, {
    key: 'handleResponse',
    value: function handleResponse(userMessageText, data) {
      var _this7 = this;

      if (data && data.responseData) {
        var response = data.responseData;

        this.checkSentiment(response);
        var isAutoEscalation = _livePersonManager2.default.isAutoEscalation(response, this.state.autoEscalateThreshold);
        _intentManager2.default.notifyIntent(this, response, isAutoEscalation, this.props.botProjectId);
        _livePersonManager2.default.setEstimatedWaitTime(response);
        this.doDiagnostics && this.addDiagnosticInfo(response);

        if (isAutoEscalation) {
          this.triggerEvent('escalate');
        } else {
          this.addDialogMessages(userMessageText, response);
        }
      } else {
        console.log('Error with chatbots-api: unknown response or response empty.');
        setTimeout(function () {
          return _this7.displayBotTypingIndicator(false);
        }, _botUtils.BOT_TYPING_DELAY);
      }
    }

    /**
     * Handle no response data and/or error response
     *
     * @param {Object} err The error object, if any
     * @private
     */

  }, {
    key: 'handleNoResponse',
    value: function handleNoResponse(err) {
      console.log('Error with chatbots-api: ' + (err || 'No error details'));
    }
  }, {
    key: 'handleEndChatOrStartOver',
    value: function handleEndChatOrStartOver() {
      var _this8 = this;

      var conversationProcessing = this.props.conversationProcessing;
      var _state2 = this.state,
          endChatConfirmed = _state2.endChatConfirmed,
          liveAgent = _state2.liveAgent;


      if (liveAgent) {
        if (endChatConfirmed) {
          this.setState({ liveAgentTyping: false });
          _livePersonManager2.default.endConnection(endChatOrStartOverEvent);

          _trafficManager2.default.sendEvent('custom', 'cx.help-bot.user.chat.end', []);
        } else {
          this.setState({ endChatConfirmed: true }, function () {
            setTimeout(function () {
              _this8.setState({ endChatConfirmed: false });
            }, 3000);
          });
        }
      } else if (!conversationProcessing) {
        this.props.conversationClear();
        this.setState({ messageText: '' }, function () {
          _this8.welcomeIfNewOrProductChanged();
        });

        _trafficManager2.default.sendEvent('custom', 'cx.help-bot.user.chat.reset', []);
      }
    }

    /**
     * Sends user message text to dialog flow
     *
     * @param {String} userMessageText send to dialogflow
     * @private
     */

  }, {
    key: 'sendUserMessageText',
    value: function sendUserMessageText(userMessageText) {
      var _this9 = this;

      _uxcore.utils.request.get(this.getChatbotApiUrl(userMessageText), { mode: 'cors' }, function (err, data) {
        err = err || data && data.err || null;
        if (err) {
          _this9.props.appBlockedSet(false);
          _this9.setState({ previousMessageText: '' });
          setTimeout(function () {
            return _this9.displayBotTypingIndicator(false);
          }, _botUtils.BOT_TYPING_DELAY);
          return _this9.handleNoResponse(err);
        }
        return _this9.handleResponse(userMessageText, data);
      });
    }

    /**
     * @returns {function} triggers event or handles request response
     *
     * @returns {Object} handling method
     * @private
     */

  }, {
    key: 'sendUserMessage',
    value: function sendUserMessage() {
      var _props2 = this.props,
          conversation = _props2.conversation,
          sessionId = _props2.sessionId,
          botProjectId = _props2.botProjectId;
      var productId = this.state.productId;

      var lastIntentId = _intentManager2.default.findLastIntentId(conversation);

      var userMessageText = this.state.messageText.trim();

      if (!this.state.liveAgent) {
        userMessageText = userMessageText.replace(/https?:\/\//, '').replace(/www\./, '');
      }

      if (userMessageText) {
        this.props.appScrolledSet(true);
        this.performScroll();

        if (userMessageText === 'clear_') {
          this.props.conversationClear();
          this.setState({ messageText: '' });
          return;
        }

        this.props.conversationAppend({ msg: userMessageText, msgType: 'user' });
        this.setMessageText('');

        if (this.state.liveAgent) {
          return _livePersonManager2.default.sendMessage(userMessageText);
        }

        _trafficManager2.default.sendUtteranceEvent('utterance', userMessageText, {
          sessionId: sessionId,
          productId: productId,
          botProjectId: botProjectId,
          lastIntentId: lastIntentId
        });

        this.props.appBlockedSet(true);
        this.displayBotTypingIndicator(true);
        this.props.conversationQueueClear();

        this.sendUserMessageText(userMessageText);
      }
    }

    /**
     * @param {Object} value the text value to set
     *
     * @private
     */

  }, {
    key: 'setMessageText',
    value: function setMessageText(value) {
      this.setState({ messageText: value });
    }

    /**
     * @param {id} id the bot project id to set
     *
     * @private
     */

  }, {
    key: 'setBotProjectId',
    value: function setBotProjectId(id) {
      this.props.appBotProjectIdSet(id);
    }

    /**
     * @returns {React.Element} renderDialogMessages
     *
     * @private
     */

  }, {
    key: 'renderDialogMessages',
    value: function renderDialogMessages() {
      var _this10 = this;

      return this.props.conversation.map(function (item, index) {
        item.index = index;

        var classes = (0, _classnames2.default)('dialog-message-container', item.msgType === 'button' ? 'dialog-message-buttons' : '', item.shown || item.msgType === 'diag' || item.msgType === 'welcome' ? '' : 'slide-in-up');

        return _react2.default.createElement(
          'div',
          {
            key: index,
            className: classes
          },
          item.msgType === 'user' ? _react2.default.createElement(_input2.default, item) : item.msgType === 'welcome' ? _react2.default.createElement(_welcome2.default, item) : item.msgType === 'text' ? _react2.default.createElement(_text2.default, item) : item.msgType === 'link' ? _react2.default.createElement(_link2.default, _extends({}, item, { locationChange: _this10.locationChange })) : item.msgType === 'image' ? _react2.default.createElement(_image2.default, item) : item.msgType === 'button' ? _react2.default.createElement(_button2.default, _extends({}, item, {
            liveAgentAvailable: _this10.state.liveAgentAvailable,
            triggerEvent: _this10.triggerEvent,
            botProjectId: _this10.props.botProjectId
          })) : item.msgType === 'search' ? _react2.default.createElement(_searchResults2.default, item) : item.msgType === 'api' ? _react2.default.createElement(_api2.default, item) : item.msgType === 'diag' ? _react2.default.createElement(_diagnostics2.default, _extends({}, item, { botProjectId: _this10.props.botProjectId })) : item.msgType === 'agentTransfer' ? _react2.default.createElement(_waitTimeClock2.default, item) : item.msgType === 'agentImage' ? _react2.default.createElement(_agentImage2.default, item) : item.msgType === 'liveAgentText' ? _react2.default.createElement(_liveAgentText2.default, item) : item.msgType === 'agentEnded' ? _react2.default.createElement(_agentEnded2.default, item) : _react2.default.createElement('div', null)
        );
      });
    }

    /**
     * @returns {React.Element} renderBotTypingIndicator
     *
     * @private
     */

  }, {
    key: 'renderBotTypingIndicator',
    value: function renderBotTypingIndicator() {
      if (this.state.botTypingIndicator || this.state.liveAgentTyping) {
        var classes = (0, _classnames2.default)('speech-bubble', 'left', this.state.liveAgentTyping ? 'agent-bubble' : '', 'slide-in-up', 'chatbot-typing-indicator');

        return _react2.default.createElement(
          'div',
          { className: classes },
          _react2.default.createElement(_loading2.default, null)
        );
      }
      return null;
    }

    /**
     * @returns {React.Element} renderDialogPanel
     *
     * @private
     */

  }, {
    key: 'renderDialogPanel',
    value: function renderDialogPanel() {
      return _react2.default.createElement(
        'div',
        {
          className: 'dialog-container'
        },
        this.renderDialogMessages(),
        this.renderBotTypingIndicator()
      );
    }

    /**
     * @returns {React.Element} renderClosePrompt
     *
     * @private
     */

  }, {
    key: 'renderClosePrompt',
    value: function renderClosePrompt() {
      var _this11 = this;

      if (!this.state.promptClose) {
        return null;
      }

      var footer = _react2.default.createElement(
        _uxcore.ButtonSet,
        null,
        _react2.default.createElement(
          _uxcore.Button,
          { design: 'primary', onClick: function onClick() {
              _this11.close();
            } },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: this.state.closePromptContinueText })
        ),
        _react2.default.createElement(
          _uxcore.Button,
          { design: 'default',
            onClick: function onClick() {
              _this11.setState({ promptClose: false });
            } },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: this.state.closePromptCancelText })
        )
      );

      return _react2.default.createElement(
        _uxcore.Modal,
        { title: this.state.closePromptTitle,
          onClose: function onClose() {
            _this11.setState({ promptClose: false });
          },
          footer: footer },
        _react2.default.createElement(
          'p',
          { className: 'm-t-2' },
          this.state.closePromptText
        )
      );
    }

    /**
     * @returns {React.Element} render
     *
     * @private
     */

  }, {
    key: 'render',
    value: function render() {
      var _this12 = this;

      return _react2.default.createElement(
        _react.Fragment,
        null,
        this.props.appChatInProgressElsewhere && _react2.default.createElement(_overlay2.default, null),
        _react2.default.createElement(
          'div',
          { className: 'chatbot-container' },
          _react2.default.createElement(
            'button',
            {
              className: 'chatbot-reset-button',
              disabled: this.props.conversationProcessing,
              onClick: this.handleEndChatOrStartOver
            },
            this.state.liveAgent ? this.state.endChatConfirmed ? 'Are you sure?' : 'End chat' : 'Start over'
          ),
          _react2.default.createElement(_reactIdleTimer2.default, {
            element: document,
            timeout: userIdleTime,
            debounce: 250,
            onIdle: this.onUserIdle,
            onActive: this.onUserActive
          }),
          _react2.default.createElement(
            'div',
            {
              className: 'chatbot-row chatbot-content',
              ref: function ref(chatDialog) {
                _this12.chatDialog = chatDialog;
              }
            },
            _react2.default.createElement(
              _errorBoundary2.default,
              null,
              this.renderDialogPanel()
            ),
            this.renderClosePrompt()
          ),
          _react2.default.createElement(
            'div',
            { className: 'chatbot-row' },
            _react2.default.createElement(_input4.default, {
              liveAgentConnecting: this.state.liveAgentConnecting,
              messageText: this.state.messageText,
              sendUserMessage: this.sendUserMessage,
              setMessageText: this.setMessageText,
              triggerEvent: this.triggerEvent,
              chatbotsApiBaseUrl: this.state.chatbotsApiBaseUrl
            })
          ),
          _react2.default.createElement('div', { id: 'helpBotLiveEngageDivId', style: { display: 'none' } })
        ),
        _react2.default.createElement(_styles2.default, null)
      );
    }
  }]);

  return HelpBot;
}(_react.Component);

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */


HelpBot.propTypes = {
  appBlockedSet: _propTypes2.default.func.isRequired,
  appBotProjectIdSet: _propTypes2.default.func.isRequired,
  appChatInProgressElsewhere: _propTypes2.default.bool.isRequired,
  appChatInProgressElsewhereSet: _propTypes2.default.func.isRequired,
  appDialogFlowSet: _propTypes2.default.func.isRequired,
  appScrolledSet: _propTypes2.default.func.isRequired,
  appScrolled: _propTypes2.default.bool.isRequired,
  botProjectId: _propTypes2.default.string,
  conversation: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  conversationAppend: _propTypes2.default.func.isRequired,
  conversationClear: _propTypes2.default.func.isRequired,
  conversationSet: _propTypes2.default.func.isRequired,
  conversationProcessing: _propTypes2.default.bool.isRequired,
  conversationProcessingSet: _propTypes2.default.func.isRequired,
  conversationQueue: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.object)).isRequired,
  conversationQueueClear: _propTypes2.default.func.isRequired,
  conversationQueueAppend: _propTypes2.default.func.isRequired,
  conversationQueueShift: _propTypes2.default.func.isRequired,
  dialogFlow: _propTypes2.default.object,
  env: _propTypes2.default.string.isRequired,
  intl: _propTypes2.default.object.isRequired,
  locationChange: _propTypes2.default.func,
  market: _propTypes2.default.string.isRequired,
  onChatMessage: _propTypes2.default.func,
  productId: _propTypes2.default.string,
  region: _propTypes2.default.string,
  sessionId: _propTypes2.default.string.isRequired,
  welcomeIntent: _propTypes2.default.string,
  chatbotsApiUrl: _propTypes2.default.string
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    appChatInProgressElsewhere: state.app.chatInProgressElsewhere,
    appScrolled: state.app.scrolled,
    botProjectId: state.app.botProjectId,
    dialogFlow: state.app.dialogFlow,
    conversation: (0, _conversation2.conversationGet)(state),
    conversationProcessing: (0, _conversation2.conversationGetProcessing)(state),
    conversationQueue: (0, _conversation2.conversationGetQueue)(state)
  };
};

var mapDispatchToProps = {
  appBlockedSet: _app.appBlockedSet,
  appChatInProgressElsewhereSet: _app.appChatInProgressElsewhereSet,
  appScrolledSet: _app.appScrolledSet,
  appBotProjectIdSet: _app.appBotProjectIdSet,
  appDialogFlowSet: _app.appDialogFlowSet,
  conversationAppend: _conversation.conversationAppend,
  conversationClear: _conversation.conversationClear,
  conversationSet: _conversation.conversationSet,
  conversationProcessingSet: _conversation.conversationProcessingSet,
  conversationQueueAppend: _conversation.conversationQueueAppend,
  conversationQueueClear: _conversation.conversationQueueClear,
  conversationQueueShift: _conversation.conversationQueueShift
};

exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HelpBot));